import { ref } from 'vue';
import { FIELD_PATTERNS } from '../../constants';

export const useFormHandling = () => {
    const form = ref<InstanceType<any> | null>(null);
    const isSubmitting = ref(false);
    const showConfirmation = ref(false);
    const isFormValid = ref(false);

    const toggleConfirmation = (show: boolean) => {
        showConfirmation.value = show;
    };

    const validateForm = async (): Promise<{ valid: boolean }> => form.value.validate();

    const validateOnInput = (): void => {
        validateForm().then(({ valid }) => {
            isFormValid.value = valid;
            form.value.resetValidation();
        });
    };

    const preventNonNumeric = (e: KeyboardEvent) => {
        if (e.ctrlKey || e.metaKey) return;
        !new RegExp(FIELD_PATTERNS.ONLY_NUMERIC_KEY).test(e.key) &&
            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Enter'].includes(e.key) &&
            e.preventDefault();
    };
    const isFormEmpty = () => !form.value;

    const toggleIsSubmitting = (value: boolean) => {
        isSubmitting.value = value;
    };

    const resetFormValidation = () => (isFormValid.value = false);

    return {
        form,
        isSubmitting,
        showConfirmation,
        isFormValid,
        validateForm,
        resetFormValidation,
        validateOnInput,
        preventNonNumeric,
        isFormEmpty,
        toggleConfirmation,
        toggleIsSubmitting
    };
};
